module.exports = __webpack_public_path__ + "img/char5.4951b7a9.svg";